module.exports = __webpack_public_path__ + "img/appleton-mmled-gen3-connect.76c1c411.png";